import { apiClient } from '@hypotenuse/common/src/utils/ApiClient'
import { PlanCategoryTab } from '@hypotenuse/common/src/utils/Interfaces'

export const fetchDefaultPlanCategoryTab = (): Promise<PlanCategoryTab> => {
  return apiClient.get('/default-plan-category-tab').then((resp) => resp.data)
}
